'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

var _Visitor = require('conversations-core/data/records/Visitor');

var _Visitor2 = _interopRequireDefault(_Visitor);

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _entity = require('conversations-core/reducers/utils/entity');

var _entity2 = _interopRequireDefault(_entity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _immutable.Map)();

exports.default = (0, _entity2.default)('visitors', (0, _reduxActions.handleActions)(_defineProperty({}, _ActionTypes2.default.RECEIVED_VISITOR_FOR_CHANNEL, function (visitors, action) {
  var visitor = action.payload.visitor;
  var vid = visitor.vid;


  return visitors.set('' + vid, (0, _Visitor2.default)(visitor));
}), initialState));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/reducers/visitors.js
// module id = 521
// module chunks = 0